import { useCallback } from "react";
import PropTypes from "prop-types";
import "./MerchandisingFilters.scss";
import { useDispatch } from "react-redux";
import MerchandisingFiltersItem from "app/pages/Merchandising/MerchandisingFilters/MerchandisingFiltersItem";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import {
	setMerchProductsFilter as setMerchProductsFilterAction,
	unsetMerchProductsFilter as unsetMerchProductsFilterAction,
} from "app/pages/Merchandising/merchandisingActionCreators";
import { useLoadingBar } from "app/features/loadingBar";

const MerchandisingFilters = ({ merchandisingTopics, onFilterSelect, activeFilter }) => {
	const { track } = useAnalytics();

	const dispatch = useDispatch();
	const { pulse } = useLoadingBar();
	const setMerchProductsFilter = useCallback(
		(...args) => dispatch(setMerchProductsFilterAction(...args)),
		[dispatch]
	);
	const unsetMerchProductsFilter = useCallback(
		(...args) => dispatch(unsetMerchProductsFilterAction(...args)),
		[dispatch]
	);
	const handleFilterSelect = useCallback(
		merchandisingTopic => {
			pulse();
			if (activeFilter === merchandisingTopic) {
				unsetMerchProductsFilter();
				onFilterSelect(undefined);
				track("merchandisingPage_filter_remove", { value: merchandisingTopic });
			} else {
				setMerchProductsFilter(merchandisingTopic);
				onFilterSelect(merchandisingTopic);
				track("merchandisingPage_filter", { value: merchandisingTopic });
			}
		},
		[onFilterSelect, merchandisingTopics]
	);

	return (
		<div className="merchandising-filters" data-testid="merchandising-filters">
			{merchandisingTopics.map((merchandisingTopic, index) => {
				return (
					<MerchandisingFiltersItem
						key={index}
						active={activeFilter === merchandisingTopic}
						onFilterSelect={handleFilterSelect}
						label={merchandisingTopic}
					/>
				);
			})}
		</div>
	);
};

MerchandisingFilters.propTypes = {
	merchandisingTopics: PropTypes.arrayOf(PropTypes.string),
	onFilterSelect: PropTypes.func,
	activeFilter: PropTypes.string,
};

MerchandisingFilters.defaultProps = {
	merchandisingTopics: [],
	onFilterSelect: () => {},
};

export default MerchandisingFilters;
